"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CustomAddress = _ref => {
  var {
    submit,
    cancel
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    onClick: submit
  }, "Yes, Continue"), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
    onClick: cancel,
    variant: "secondary"
  }, "No, Don't Continue"));
};
var _default = exports.default = CustomAddress;